import Vue from 'vue'

export default {
	props: {
		movies: Array,
		label: {
			type: String,
			default: 'Related movies'
		},
		link:{type:String,default:"/"},
		limit: {"type":String,default:"6"}
	},

	// data() {
	// 	return {
	// 		slicedMovies: this.movies
	// 	}
	// },

	computed:{
		slicedMovies(){
			let movies = this.movies.slice(0);
			if (this.limit !== undefined && parseInt(this.limit) !== 0) {
				movies.splice(parseInt(this.limit), movies.length)
			}

			return movies;

		}
	},

	methods: {
		showMovieDetail(id) {

			if(this.$route.params.festival_id){
				// console.log('here');
				this.$router.push(`/details/${id}/film-festival/${this.$route.params.festival_id}`)
			}else
			this.$router.push({name: 'Movie Details', params: {id: id}})
		}
	},

}


// WEBPACK FOOTER //
// ./src/components/generic/related-movies/related-movies.js